module.exports = __webpack_public_path__ + "img/line-chart-up-04.fdfb3faa.svg";